import { c as n } from "../../../../index.esm-BeDSGXP5.js";
import { css as r } from "styled-components";
const t = {
  wrapper: ({ theme: o }) => /* @__PURE__ */ r([
    "display:flex;",
    ";"
  ], n({
    backgroundColor: o.componentColors.cookieBanner.background,
    borderColor: o.componentColors.cookieBanner.borderColor,
    position: "fixed",
    bottom: 0
  })),
  heading: ({ theme: o }) => /* @__PURE__ */ r([
    "",
    ";"
  ], n({
    color: o.componentColors.cookieBanner.headingText,
    paddingX: [
      "sm",
      "md"
    ]
  })),
  textVariant: "dark",
  rejectButtonVariant: "secondary",
  manageButtonVariant: "textLink",
  zIndex: 9900
};
export {
  t as default
};
